import type { FetchModelResponse } from '@cian/http-api';

import type { IPublicSendValidationCodeResponse } from '../../../repositories/sms/entities/PublicValidationCode/PublicSendValidationCodeResponse';
import type { TSendValidationCodeResponse } from '../../../repositories/sms/v2/send-validation-code';
import { ResponseError } from '../../../utils/errors';

interface IPhoneValidationError {
  code: string;
  message: string;
}

export function assertError(
  response: TSendValidationCodeResponse,
): asserts response is FetchModelResponse<200, 'json', IPublicSendValidationCodeResponse> {
  if (response.statusCode !== 400) {
    return;
  }

  const phoneFormatError = response.response.errors?.find(
    (error: IPhoneValidationError) => error.code === 'phone_number_is_invalid',
  );

  if (phoneFormatError) {
    throw new ResponseError({
      domain: 'requestPhoneValidationCode',
      message: (phoneFormatError as IPhoneValidationError).message,
      details: { customerPhone: (phoneFormatError as IPhoneValidationError).message },
    });
  } else {
    throw new ResponseError({
      domain: 'requestPhoneValidationCode',
      message: response.response.message || 'Попробуйте ещё раз.',
      details: { phoneVerification: response.response.message || 'Попробуйте ещё раз.' },
    });
  }
}
